import React, { Fragment, useState, KeyboardEvent, MouseEvent } from 'react';
import {
    Box,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import AppsIcon from '@material-ui/icons/Apps';
import CodeIcon from '@material-ui/icons/Code';
import SubjectIcon from '@material-ui/icons/Subject';
import AccountIcon from '@material-ui/icons/AccountCircle';

import { useNavigate } from 'react-router-dom';
import { useLogout } from '../../hooks/useLogout';
import { useUser } from '../../utils/user';

type Anchor = 'top';

export const MobileDrawer = () => {
    const navigate = useNavigate();
    const [logout] = useLogout();
    const user = useUser();
    const isLoggedIn = Boolean(user !== null);

    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const toggleDrawer = (anchor: Anchor, open: boolean) => (event: KeyboardEvent | MouseEvent) => {
        if (
            event.type === 'keydown' &&
            ((event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor: Anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem button onClick={() => navigate('/apps')}>
                    <ListItemIcon>
                        <AppsIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Apps'} />
                </ListItem>
                <ListItem button onClick={() => navigate('/developer')}>
                    <ListItemIcon>
                        <CodeIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Developers'} />
                </ListItem>
                <ListItem button onClick={() => (window.location.href = 'https://bokun.dev/')}>
                    <ListItemIcon>
                        <SubjectIcon />
                    </ListItemIcon>
                    <ListItemText primary={'Docs'} />
                </ListItem>
                <Divider />
                {isLoggedIn ? (
                    <ListItem button onClick={() => navigate('/extranet')}>
                        <ListItemIcon>
                            <AccountIcon />
                        </ListItemIcon>
                        <ListItemText primary={'My account'} />
                    </ListItem>
                ) : (
                    <ListItem button onClick={() => navigate('/developer/login')}>
                        <ListItemIcon>
                            <i className="material-icons">login</i>
                        </ListItemIcon>
                        <ListItemText primary={'Login'} />
                    </ListItem>
                )}
                {!isLoggedIn && (
                    <ListItem button onClick={() => navigate('/developer/signup')}>
                        <ListItemIcon>
                            <i className="material-icons">person_add_alt</i>
                        </ListItemIcon>
                        <ListItemText primary={'Signup'} />
                    </ListItem>
                )}
                {isLoggedIn && (
                    <ListItem
                        button
                        onClick={() => {
                            logout();
                            navigate('/#');
                        }}
                    >
                        <ListItemIcon>
                            <i className="material-icons">logout</i>
                        </ListItemIcon>
                        <ListItemText primary={'Logout'} />
                    </ListItem>
                )}
            </List>
        </Box>
    );

    return (
        <>
            {(['top'] as const).map(anchor => (
                <Fragment key={anchor}>
                    <IconButton onClick={toggleDrawer(anchor, true)}>
                        <MenuIcon fontSize="large" />
                    </IconButton>
                    <Drawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                    >
                        {list(anchor)}
                    </Drawer>
                </Fragment>
            ))}
        </>
    );
};
